import {changeRangeFilter} from "../actions/filters";
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import React, {Component} from 'react';
/**
 * Just a wrapper under list items
 *
 */
class UiSlider extends Component {

    static propTypes = {
        minValue: PropTypes.number,
        maxValue: PropTypes.number,
        filterId: PropTypes.number,
        maxValueLimit: PropTypes.number
    };

    /**
     * Handling change props that passed to ui-Slider component via redux see mapsStateToProps
     *
     * @param event
     * @param newValue
     */
    handleChange = (event, newValue) => {
        // console.log("new Value handle change", newValue);
        // console.log("new this.props.filterId", this.props.filterId);
        this.props.handleChangeFilter(newValue[0],newValue[1],this.props.filterId);
    };


    /**
     * render
     *
     * @returns {*}
     */



    render() {
        return (
            <div>
                <Typography id="range-slider" gutterBottom>
                    Min max
                </Typography>
                <Slider
                    value={[this.props.minValue,this.props.maxValue]}
                    max={this.props.maxValueLimit}
                    onChange={this.handleChange}
                    valueLabelDisplay="auto"
                    aria-labelledby="range-slider"
                    getAriaValueText={this.valueText} />
            </div>
        )
    }
}

/**
 * Should be optimized in future
 *
 * @param store
 * @param ownProps
 * @returns {{minValue: *, maxValue}}
 */
const mapStateToProps = (store, ownProps) => {
    const {minMaxSelected, filterIdTriggered} = store.goods;
    if (minMaxSelected.length == 0) {
        var minValue = ownProps.minValue;
        var maxValue = ownProps.maxValue;
    } else if (filterIdTriggered == ownProps.filterId && minMaxSelected[ownProps.filterId] !== undefined) {
        var minValue = minMaxSelected[ownProps.filterId].min;
        var maxValue = minMaxSelected[ownProps.filterId].max;
    } else if (filterIdTriggered != ownProps.filterId && minMaxSelected[ownProps.filterId] !== undefined){
        var minValue = minMaxSelected[ownProps.filterId].min;
        var maxValue = minMaxSelected[ownProps.filterId].max;
    } else if ( filterIdTriggered != ownProps.filterId && minMaxSelected[ownProps.filterId] == undefined ){
        var minValue = ownProps.minValue;
        var maxValue = ownProps.maxValue;
    }
    var data = {
        minValue: minValue,
        maxValue: maxValue
    }
    return data;
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleChangeFilter: (minValue,maxValue,filterId) => {
            dispatch( changeRangeFilter(minValue, maxValue, filterId) );
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UiSlider)
